import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toggleLoginBox } from 'components/Login/redux';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import {
  loginWithFBEventEmitter,
  loginWithGoogleEventEmitter,
} from '../../components/Login/Login';
import { loadFacebookJs } from '../../utils/common';
import { SIGNAL_EVENT_TYPES, SIGNAL_EVENT_NAMES } from '../../constants';

function sendGACall(cat, act, lbl) {
  analyticsWrapper('gaAndGrx', 'send', 'event', cat, act, lbl);
}
class CommentWriteBox extends React.Component {
  static propTypes = {
    userData: PropTypes.shape({
      isLoggedIn: PropTypes.bool,
    }),
    pageMsid: PropTypes.string.isRequired,
    isUserLoggedin: PropTypes.func.isRequired,
    handleAddComment: PropTypes.func.isRequired,
    openLoginBox: PropTypes.func.isRequired,
    getParentComment: PropTypes.func,
    getMsid: PropTypes.func,
    toggleResponses: PropTypes.func,
    showAddCommentBox: PropTypes.func,
    renderUserIcon: PropTypes.func.isRequired,
    disclaimer: PropTypes.func,
    showCloseButton: PropTypes.bool,
    styles: PropTypes.shape({}).isRequired,
    prime: PropTypes.bool,
    isWapView: PropTypes.bool,
    mainCommentBox: PropTypes.bool,
    commentTextInputRef: PropTypes.shape({}).isRequired,
    showVerificationMsg: PropTypes.bool,
    showFixedHeader: PropTypes.bool,
    hideFixedHeader: PropTypes.func,
    seoData: PropTypes.shape({}),
    isPrivateUser: PropTypes.bool,
  };
  static defaultProps = {
    userData: undefined,
    getParentComment: undefined,
    getMsid: undefined,
    toggleResponses: undefined,
    showAddCommentBox: undefined,
    showCloseButton: false,
    prime: false,
    isWapView: false,
    mainCommentBox: false,
    disclaimer: () => {},
    showVerificationMsg: false,
    showFixedHeader: false,
    hideFixedHeader: () => {},
    seoData: {},
    isPrivateUser: true,
  };
  constructor() {
    super();
    this.state = {
      isCommentWriteBoxVisible: true,
      errorMsg: '',
      showLoginBox: false,
      showDisclaimer: false,
      name: '',
      email: '',
      loc: '',
      captcha: '',
      commentBoxInput: '',
    };
    this.captchaSum = 0;
    this.messages = {
      login_required: 'Please login to post your comment.',
      name_required: 'Please enter your name.',
      location_required: 'Please enter your location.',
      captcha_required: 'Please enter captcha value.',
      name_toolong: 'Name cannot be longer than 30 chars.',
      name_not_string: 'Name can only contain alphabets.',
      location_toolong: 'Location cannot be longer than 30 chars.',
      location_not_string: 'Location can only contain alphabets.',
      captcha_toolong: 'Captcha cannot be longer than 4 chars.',
      captcha_number_only: 'Captcha value can only be a number.',
      captcha_invalid: 'Please enter a valid captcha value.',
      email_required: 'Please enter your email address.',
      email_invalid: 'Please enter a valid email address.',
      empty_message: "You can't post this review as it is blank.",
    };

    this.fbRef = React.createRef();
    this.twitterRef = React.createRef();
  }

  componentWillMount() {
    this.captchaText = this.getCaptchaText();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userData.isLoggedIn !== this.props.userData.isLoggedIn) {
      this.showError();
    }
  }

  handleCommentBoxInput = e => {
    this.setState({ commentBoxInput: e.target.value });
  };

  getCaptchaText() {
    const val1 = Math.floor(Math.random() * 10);
    const val2 = Math.floor(Math.random() * 10);
    const sum = val1 + val2;
    this.captchaSum = sum;
    return `${val1}+${val2}=`;
  }

  inputChangeName = e => {
    const val = e.target.value;
    this.setState({ name: val });
  };

  inputChangeEmail = e => {
    const val = e.target.value;
    this.setState({ email: val });
  };

  inputChangeLoc = e => {
    const val = e.target.value;
    this.setState({ loc: val });
  };

  inputChangeCaptcha = e => {
    const val = e.target.value;
    this.setState({ captcha: val });
  };

  onKeyPress(event) {
    if (event.which === 13) {
      this.addComment();
    }
  }

  resetCommentBox() {
    this.setState({ commentBoxInput: '' });
  }

  showError(errorMsg = '') {
    this.setState({
      errorMsg,
    });
  }

  alphaOnly = str => /^[A-z\s]+$/.test(str);

  email = email => {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  isNonLoggedInFormValid = () => {
    let validForm = false;
    let errorMsg = '';
    const user = {};
    const { name, email, loc, captcha } = this.state;
    user.name = name.trim();
    user.email = email.trim();
    user.loc = loc.trim();
    user.captcha = captcha.trim();
    if (this.props.isPrivateUser) {
      errorMsg = this.messages.login_required;
    } else if (user.name.length === 0) {
      errorMsg = this.messages.name_required;
    } else if (!this.alphaOnly(user.name)) {
      errorMsg = this.messages.name_not_string;
    } else if (user.email.length === 0) {
      errorMsg = this.messages.email_required;
    } else if (!this.email(user.email)) {
      errorMsg = this.messages.email_invalid;
    } else if (user.loc.length === 0) {
      errorMsg = this.messages.location_required;
    } else if (!this.alphaOnly(user.loc)) {
      errorMsg = this.messages.location_not_string;
    } else if (!user.captcha) {
      errorMsg = this.messages.captcha_required;
    } else if (
      // eslint-disable-next-line no-restricted-globals
      isNaN(user.captcha) ||
      parseInt(user.captcha, 10) !== this.captchaSum
    ) {
      errorMsg = this.messages.captcha_invalid;
    } else {
      validForm = true;
    }

    this.setState({ errorMsg });

    return { validForm, user };
  };

  addComment() {
    let actualCategory;
    let parentComment;
    const commentText = this.state.commentBoxInput;
    let user;
    const isUserLoggedin = this.props.isUserLoggedin(this.props.userData);

    if (!this.checkIfCommentIsEmpty()) {
      return;
    }

    if (!isUserLoggedin) {
      const details = this.isNonLoggedInFormValid();
      if (!details.validForm) {
        return;
      }

      user = { ...details.user };
    }

    this.showError();

    /*
     * 1. rootid & commentRespondingTo are 0 for root comment
     *	 i.e no parent comment ( level 0 )
     * 2. for child comment ( level 1 ), both have same value
     * 3. for child's child comment ( level 2 ),
     *    parent is recent parent ( level 2 )
     *    root is level 1
     */
    if (
      this.props.getParentComment &&
      typeof this.props.getParentComment === 'function'
    ) {
      parentComment = this.props.getParentComment();
    }

    const rootid = (parentComment && parentComment.msid) || 0;
    const commentRespondingTo =
      (this.props.getMsid && this.props.getMsid()) || 0;
    const { pageMsid } = this.props;

    const commentData = {
      message: commentText,
      rootid,
      //commentRespondingTo : this.props.getImmediateParent().msid || rootid,
      parentid: commentRespondingTo,
      ArticleID: pageMsid,
      msid: pageMsid,
    };
    if (isUserLoggedin) {
      this.props.handleAddComment(commentData);
      this.setState({ showVerifyMessage: false });
      this.postToSocial(commentData.message);
    } else {
      this.props.handleAddComment(commentData, user);
      this.setState({ showVerifyMessage: true });
    }
    this.resetCommentBox();
    if (this.props.toggleResponses) this.props.toggleResponses(true);
    if (this.props.showAddCommentBox) this.props.showAddCommentBox(false);

    if (typeof window !== 'undefined' && window.categoryForGA) {
      actualCategory = `${window.categoryForGA}`;
    } else {
      actualCategory = `WEB-${window.location.href}`;
    }
    sendGACall(
      actualCategory,
      'comment-submit-comment_section',
      `msid_${this.props.pageMsid}`,
    );
    analyticsWrapper('grx', 'track', SIGNAL_EVENT_NAMES.comment, {
      signalEventType: SIGNAL_EVENT_TYPES.comment,
    });
  }

  postToSocial = comment => {
    const data = { ...this.socialSiteObj(), message: comment };
    let twtShare = false;
    let fbShare = false;
    if (
      this.twitterRef &&
      this.twitterRef.current &&
      this.twitterRef.current.checked
    ) {
      this.postToTwitter(data);
      twtShare = true;
    }

    if (this.fbRef && this.fbRef.current && this.fbRef.current.checked) {
      loadFacebookJs(() => {
        this.postToFB(data);
      });
      fbShare = true;
    }

    if (twtShare) {
      sendGACall(
        'comment',
        'submit-twtshare-comment_section',
        `msid_${this.props.pageMsid}`,
      );
    }

    if (fbShare) {
      sendGACall(
        'comment',
        'submit-fbshare-comment_section',
        `msid_${this.props.pageMsid}`,
      );
    }
  };

  socialSiteObj = () => {
    const { seoData } = this.props;
    const data = {
      link: seoData.canonical || this.getMeta('og:url'),
      title: seoData.title || this.getMeta('og:title'),
      domain: window.location.host,
      picture: seoData.ogimage || this.getMeta('og:image'),
      desc: seoData.description || this.getMeta('og:description'),
    };

    return data;
  };

  getMeta = property => {
    if (!property) {
      return '';
    }

    let data = '';

    const elem = document.querySelector(`meta[property='${property}']`);
    if (elem) {
      data = elem.getAttribute('content');
    }

    return data;
  };

  postToFB = data => {
    window.FB.ui({
      method: 'feed',
      message: data.message,
      name: data.title,
      link: data.link,
      picture: data.picture,
      caption: data.domain,
      description: data.desc,
    });
  };

  postToTwitter = data => {
    window.open(
      `https://twitter.com/intent/tweet?text=${escape(data.message)} - ${
        data.link
      }&original_referer=https://${window.location.hostname}/share.cms`,
      'socialPost',
      'width=600,height=230,left=383,top=249,scrollbars=0,resizable=false',
    );
  };

  showDisclaimer = () => {
    const stateObj = {};
    let changeState = false;
    const isLoggedin = this.props.isUserLoggedin(this.props.userData);
    if (!this.state.showDisclaimer) {
      stateObj.showDisclaimer = true;
      changeState = true;
    }

    if (!isLoggedin && !this.state.showLoginBox) {
      stateObj.showLoginBox = true;
      changeState = true;
    }

    if (changeState) {
      this.setState({ ...stateObj });
    }
  };

  showLoginScreen = () => {
    if (!this.checkIfCommentIsEmpty()) {
      return;
    }

    this.props.openLoginBox(true);
  };

  loginWithFb = () => {
    if (!this.checkIfCommentIsEmpty()) {
      return;
    }
    loginWithFBEventEmitter();
  };

  loginWithGoogle = () => {
    if (!this.checkIfCommentIsEmpty()) {
      return;
    }
    loginWithGoogleEventEmitter();
  };

  checkIfCommentIsEmpty = () => {
    let validComment = true;
    const commentText = this.state.commentBoxInput;
    if (!commentText || !commentText.trim()) {
      this.showError(this.messages.empty_message);
      validComment = false;
    }

    return validComment;
  };

  getLoginBox() {
    const s = this.props.styles;
    return (
      <div
        className={`${s.signinform} clearfix ${
          this.props.isPrivateUser ? s.euUser : ''
        }`}
      >
        <div className="clearfix">
          {!this.props.isPrivateUser && (
            <>
              <div className={s.signin}>
                <h3>Continue without login</h3>
                <input
                  className={s.textbox}
                  placeholder="Full Name"
                  onChange={e => this.inputChangeName(e)}
                  value={this.state.name}
                  maxLength="30"
                />
                <input
                  className={s.textbox}
                  placeholder="Email"
                  onChange={e => this.inputChangeEmail(e)}
                  value={this.state.email}
                />
                <input
                  className={`${s.textbox} ${s.location}`}
                  placeholder="Location"
                  onChange={e => this.inputChangeLoc(e, 'loc')}
                  value={this.state.loc}
                  maxLength="30"
                />
                <span className={`${s.mathbox} clearfix`}>
                  <span>{this.captchaText}</span>
                  <input
                    className={s.textbox}
                    onChange={e => this.inputChangeCaptcha(e)}
                    value={this.state.captcha}
                    maxLength="4"
                  />
                </span>
              </div>
              <div className={s.divider}>
                <span>or</span>
              </div>
            </>
          )}
          <div className={s.socialsignin}>
            <h3>Login from existing account</h3>
            {/* <span
                className={s.fb}
                title="Facebook"
                onClick={() => {
                  this.loginWithFb();
                }}
              >
                <small>Facebook</small>
              </span> */}
            <span
              className={s.google}
              title="Google"
              onClick={() => this.loginWithGoogle()}
            >
              <small>Google</small>
            </span>
            <span
              className={s.email}
              title="Email"
              onClick={this.props.toggleLoginBox}
            >
              <small>Email</small>
            </span>
          </div>
        </div>
      </div>
    );
  }

  closeCommentReply = () => {
    this.props.showAddCommentBox(false);
  };

  render() {
    const isUserLoggedin = this.props.isUserLoggedin(this.props.userData);
    const userIcon = this.props.renderUserIcon();
    const s = this.props.styles;
    const showFixedHeader =
      this.props.mainCommentBox && this.props.showFixedHeader;

    return (
      <>
        {this.state.isCommentWriteBoxVisible && (
          <div className={showFixedHeader ? s.commenttopareafixed : ''}>
            <div
              className={`${s.comment_input} ${s.top_input} ${
                this.props.isWapView ? s.mobile : ''
              }`}
            >
              {!this.props.prime && userIcon}
              {this.props.mainCommentBox && (
                <textarea
                  id={`comment-sidebar-input-${this.props.pageMsid}`}
                  type="text"
                  placeholder="Leave a comment…"
                  aria-label="leave comment"
                  cols="40"
                  rows="5"
                  maxLength="3000"
                  ref={this.props.commentTextInputRef}
                  onKeyPress={e => this.onKeyPress(e)}
                  onFocus={() => this.showDisclaimer()}
                  onChange={this.handleCommentBoxInput}
                  value={this.state.commentBoxInput}
                />
              )}

              {!this.props.mainCommentBox && (
                <textarea
                  type="text"
                  placeholder="Leave a comment…"
                  aria-label="leave comment"
                  cols="40"
                  rows="5"
                  maxLength="3000"
                  onKeyPress={e => this.onKeyPress(e)}
                  onFocus={() => this.showDisclaimer()}
                  onChange={this.handleCommentBoxInput}
                  value={this.state.commentBoxInput}
                />
              )}

              <button
                aria-label="add comment"
                onClick={() => this.addComment()}
              />
              <span className={s.numbertxt}>
                {this.state.commentBoxInput.length}
                /3000
              </span>
              {this.props.showCloseButton && (
                <div
                  className={s.close}
                  onClick={() => {
                    this.closeCommentReply();
                  }}
                >
                  +
                </div>
              )}
            </div>
            {this.state.errorMsg && (
              <div className={s.commentposterror}>{this.state.errorMsg}</div>
            )}
            {this.state.showLoginBox &&
              !this.props.userData.isLoggedIn &&
              this.getLoginBox()}
            {!this.props.prime &&
              !this.props.isWapView &&
              isUserLoggedin &&
              this.state.showDisclaimer && (
                <div className={`${s.socialpost} clearfix`}>
                  <label className={s.fb}>
                    <i className={s.iconfb} />
                    <input type="checkbox" ref={this.fbRef} />
                    <span>Share on Facebook</span>
                  </label>
                  <label className={s.twitter}>
                    <i className={s.icontwitter} />
                    <input type="checkbox" ref={this.twitterRef} />
                    <span>Share on Twitter</span>
                  </label>
                </div>
              )}
            {this.state.showDisclaimer && (
              <p className={s.disclaimer}> {this.props.disclaimer()}</p>
            )}
            {this.props.showVerificationMsg &&
              this.state.showVerifyMessage && (
                <div className={s.commentverificationmsg}>
                  We have sent you a verification email. To verify, just follow
                  the link in the message
                </div>
              )}
            {showFixedHeader && (
              <span
                className={s.closefixheadersection}
                onClick={() => this.props.hideFixedHeader()}
              >
                HIDE
              </span>
            )}
          </div>
        )}
      </>
    );
  }
}
CommentWriteBox.propTypes = {
  toggleLoginBox: PropTypes.func.isRequired,
};
const mapDispatchToProps = dispatch => ({
  toggleLoginBox: params => {
    dispatch(toggleLoginBox(params));
  },
});

export default connect(null, mapDispatchToProps)(CommentWriteBox);
